import { Kind } from "graphql";
export function getFragmentDefinitions(ast) {
    return ast.definitions.filter((def)=>def.kind === Kind.FRAGMENT_DEFINITION);
}

//# sourceMappingURL=fragment.js.map